import { NavigationLevelPathConfig } from '~/components/Sidebar/SidebarMenu/SidebarMenuLevel';
import { NavigationRoutingStructure } from '~/scenes/PortalViews/components/StructuredModuleRouter';

export const resolveValidRoutingStructure = (
  structure: NavigationRoutingStructure[],
): NavigationRoutingStructure[] => {
  return structure.reduce((acc, item) => {
    const isAvailable = item.isAvailable !== false;

    // Omit unavailable item
    if (!isAvailable) {
      return acc;
    }

    const processedSubPaths = !!item.subPaths
      ? resolveValidRoutingStructure(item.subPaths)
      : [];

    // Include item with content or sub-content
    if (!!item.component || !!processedSubPaths.length) {
      acc.push({
        ...item,
        subPaths: processedSubPaths,
      });
    }

    return acc;
  }, [] as NavigationRoutingStructure[]);
};

export const convertToNavigationLevelPathConfig = (
  structureLevel: NavigationRoutingStructure[],
): NavigationLevelPathConfig[] => {
  return structureLevel.map((item) => {
    const { subPaths, component, ...levelItem } = item;

    const convertedSubPaths = !!subPaths
      ? convertToNavigationLevelPathConfig(subPaths)
      : undefined;

    return {
      ...levelItem,
      subPaths: convertedSubPaths,
    };
  });
};
